import React from "react";
import { Box, Typography } from "@mui/material";
import StatusIndicatorSmall from "../StatusIndicatorSmall";
import { useTranslation } from "react-i18next";

const StatusBox = (props:any) => {
    const { reportType, status } = props;
    const [t] = useTranslation();

    return (
      <Box sx={{ display: "flex"}}>
        <Typography className="fs12 fw700 mtbAuto">{t('STATUS')}</Typography>
        <Box sx={{ width: '120px', ml: '5px' }}className={'mtbAuto'}>
          <StatusIndicatorSmall reportType={reportType} status={status} />
        </Box>
      </Box>
    )
}

export default StatusBox;